import StreamCreatePage from "./StreamCreatePage";

export default StreamCreatePage;